module.exports = __webpack_public_path__ + "static/media/hacken.d13baa37.svg";